import React from 'react';
import styled from 'styled-components';

import Icon from 'js/components/common/Icon';
import LoadingMessage from './LoadingMessage';

export default styled(({ className, message }) => (
  <div className={className}>
    <Icon spin name="refresh" />
    <LoadingMessage>{message}</LoadingMessage>
  </div>
)).attrs({ spin: true, name: 'refresh' })`
  padding: 1rem;
  text-align: center;
`;
